import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db, firebaseListo } from "./firebase";
import { generarCodigo } from "./format";
import { EMPRESA, IGV } from "./config";

/**
 * Envio de formularios (cotizacion, pedido, contacto).
 *
 * Si Firebase todavia no esta configurado, no se pierde la solicitud: se
 * devuelve `modo: "sin-backend"` y la interfaz ofrece el mismo contenido por
 * WhatsApp para que el equipo comercial no se quede sin el dato.
 */

async function guardar(coleccion, datos) {
  if (!firebaseListo) return { ok: true, modo: "sin-backend", id: null };
  const ref = await addDoc(collection(db, coleccion), {
    ...datos,
    createdAt: serverTimestamp(),
  });
  return { ok: true, modo: "firestore", id: ref.id };
}

export async function enviarCotizacion({ cliente, items, mensaje }) {
  const codigo = generarCodigo("COT");
  const subtotal = items.reduce(
    (acc, i) => acc + (i.precio ?? 0) * i.cantidad,
    0
  );

  const resultado = await guardar("cotizaciones", {
    codigo,
    cliente,
    items,
    mensaje: mensaje || "",
    subtotal,
    igv: subtotal * IGV,
    total: subtotal * (1 + IGV),
    estado: "nueva",
    origen: "web",
  });

  return { ...resultado, codigo };
}

export async function enviarPedido({ cliente, items, entrega, clienteUid }) {
  const codigo = generarCodigo("PED");
  const subtotal = items.reduce(
    (acc, i) => acc + (i.precio ?? 0) * i.cantidad,
    0
  );
  const costoEnvio = entrega?.costo ?? 0;

  const resultado = await guardar("pedidos", {
    codigo,
    cliente,
    clienteUid: clienteUid || null,
    items,
    entrega,
    subtotal,
    costoEnvio,
    igv: (subtotal + costoEnvio) * IGV,
    total: (subtotal + costoEnvio) * (1 + IGV),
    estado: "pendiente",
    origen: "web",
  });

  return { ...resultado, codigo };
}

export async function enviarMensaje({ nombre, email, telefono, asunto, mensaje }) {
  return guardar("mensajes", {
    nombre,
    email,
    telefono: telefono || "",
    asunto: asunto || "Consulta desde la web",
    mensaje,
    leido: false,
  });
}

/** Arma el texto de WhatsApp con el detalle del carrito o la consulta. */
export function enlaceWhatsApp(texto) {
  const numero = String(EMPRESA.whatsapp).replace(/\D/g, "");
  return `https://wa.me/${numero}?text=${encodeURIComponent(texto)}`;
}

export function resumenParaWhatsApp({ codigo, cliente, items }) {
  const lineas = items.map(
    (i) => `- ${i.cantidad} ${i.unidad} · ${i.nombre} (${i.sku})`
  );
  return [
    `Hola ${EMPRESA.nombre}, quiero cotizar:`,
    "",
    ...lineas,
    "",
    cliente?.nombre ? `Nombre: ${cliente.nombre}` : "",
    cliente?.empresa ? `Empresa: ${cliente.empresa}` : "",
    cliente?.telefono ? `Telefono: ${cliente.telefono}` : "",
    codigo ? `Referencia: ${codigo}` : "",
  ]
    .filter(Boolean)
    .join("\n");
}
